<template>
    <div class="login_container">
        <!-- 头像 -->
        <div class="login_box">
            <!-- <div class="avatar_box">
                <img src="../assets/logo.png" alt="">
            </div> -->
            <div class="avatar_title">
                <span>智慧停车优惠券商家登录</span>
            </div>
            <!-- 表单 -->
            <el-form ref="loginFromRef" :model="loginForm" :rules="lofinFormRules" label-width="0px" class="login_form">
                <!-- 用户名 -->
                <el-form-item prop="userName">
                    <el-input v-model="loginForm.userName" prefix-icon="iconfont icon-user"></el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="passWord">
                    <el-input v-model="loginForm.passWord" prefix-icon="iconfont icon-3702mima" type="password"></el-input>
                </el-form-item>
                <!-- 按钮 -->
                <el-form-item class="btns">
                    <el-button type="primary" @click="login" :loading="loginLoading">商家登录</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      loginLoading: false,
      // 登录表单数据对象
      loginForm: {
        userName: '',
        passWord: ''
      },

      // 登录表单验证规则
      lofinFormRules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        passWord: [
          { required: true, message: '请输入密码', trigger: 'blur' }]
      }

    }
  },
  methods: {
    // 商户登录
    login () {
      this.$refs.loginFromRef.validate(async valid => {
        if (!valid) return false
        try {
          this.loginLoading = true
          const { data: res } = await this.$http.get('merchantQRLogin.do?', {
            params: { userName: this.loginForm.userName, passWord: this.loginForm.passWord }
          })
          if (res.code === '0') {
            // this.$message.success(res.message)
            window.sessionStorage.setItem('token', res.data)// 将session保存到sessionStorage中
            this.$router.push('/autoQr')// 跳转二维码展示页面
          } else {
            return this.$message.error(res.message)
          }
        } catch (e) {
          this.$message.error('登录失败')
        } finally {
          this.loginLoading = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login_container{
    background-color: #cccccc;
    height: 100%;
}
.login_box{
    width: 400px;
    height: 250px;
    background-color:#fff;
    position:absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    .avatar_title{
      width: 300px;
      height: 50px;
      line-height: 50px;;
      margin-top: 10px;
      position: absolute;
      left: 50%;
      margin-left: -150px;
      text-align:center;
      color: #E16531;
      font-family: "微软雅黑", "Helvetica";
      font-size: 24px;
      font-weight: 600;
    }
}

.login_form{
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
}

.btns{
    display: flex;
    justify-content: flex-end
}
</style>
